import { Campaign } from '@app/types/api';

export const getCampaignOptionsFromResponse = (
    campaignsResponse: Campaign[],
) => {
    return campaignsResponse.reduce((acc, c) => {
        acc[c.id] = {
            name: c.name,
            value: c.id,
        };
        return acc;
    }, []);
};
